import { http } from '@/utils/http';

// baseInfo
export function baseinfo(voteName: string) {
  return http.get('/vote/' + voteName + '/controller.php?enews=base-info');
}

// 投票列表页
export function getlist(
  voteName: string,
  page?: number,
  name?: string,
  data?: any,
) {
  if (data) {
    return http.get(
      '/vote/' +
        voteName +
        '/controller.php?enews=' +
        name +
        '&search=' +
        data +
        '&page=' +
        page,
    );
  } else {
    return http.get(
      '/vote/' + voteName + '/controller.php?enews=' + name + '&page=' + page,
    );
  }
}

// 新闻列表
export function getnewslist(voteName: string, page: number) {
  return http.get(
    '/vote/' + voteName + '/controller.php?enews=news-list&page=' + page,
  );
}

// 活动规则
export function getrules(voteName: string) {
  return http.get('/vote/' + voteName + '/controller.php?enews=rules');
}

// 详情页
export function getdetail(voteName: string, name: any, id: number) {
  return http.get(
    '/vote/' + voteName + '/controller.php?enews=' + name + '&id=' + id,
  );
}

// 视频
export function getvideo(voteName: string) {
  return http.get('/vote/' + voteName + '/controller.php?enews=call');
}
